export default {
    AUTH_TOKEN: "auth",
};
